// --------------------------------------------------------
// FORMIKTEXTFIELD - FormikTextField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { TextField } from '@mui/material'
import { useField } from 'formik';
import styled from 'styled-components'
import InputMask from "react-input-mask";

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// FORMIKTEXTFIELD INTERFACE
// --------------------------------------------------------

/**
/**
 * A component that renders a Formik text field.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
export const StyledTextField = styled(TextField)`
 `

const FormikTextField = (props: any) => {
  // --------------------------------------------------------
  // FORMIKTEXTFIELD PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { inputRef, onChange, ...other } = props;
  const [field, meta, helpers] = useField(props.name);

  const { value } = meta;
  const { setValue } = helpers;

  const isFieldEstado = field.name === 'estado';

  // --------------------------------------------------------
  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      <InputMask
        {...other}
        mask={props.mask}
        value={isFieldEstado ? value.toUpperCase() : value}
        getInputRef={inputRef}
        onChange={(event) => setValue(isFieldEstado ? event.target.value.toUpperCase() : event.target.value)}
        onKeyPress={e => { e.key === 'Enter' && e.preventDefault() }}
        disabled={props.disabled}
        maskPlaceholder=""
      >
        <StyledTextField {...other} />
      </InputMask>
    </>
  )
  // --------------------------------------------------------
}

export default FormikTextField